import { QueryClient } from "@tanstack/react-query";

// #redesign Welle C (#10): Poll-Intervall für Live-Sichten (Listen + Agent-Detail).
// Hält Phase/Heartbeat/Auslastung aktuell ohne manuellen Refresh. 15s = Kompromiss
// Aktualität vs. Last (Channel-Detail hat sein eigenes 5s-Pairing-Polling).
export const LIVE_REFETCH_MS = 15_000;

// Zentraler QueryClient.
// staleTime: 30s — Admin-UI darf kurz veralteten Cache zeigen
// refetchOnWindowFocus: true — Admin wechselt zwischen Tabs, beim Zurückkommen frisch
// retry: 1 — Single retry bei Network-Fehler (ApiError 4xx wird nicht retried, siehe queryFn)
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: 1,
        // gcTime (formerly cacheTime): wie lange unused queries im Cache bleiben
        gcTime: 5 * 60_000,
      },
    },
  });
}

// QueryKey-Schema (siehe Ticket #163 Architektur-Entscheidungen):
//   ["resources", "<type>", "list"]    → Liste aller Items
//   ["resources", "<type>", id]        → Detail eines Items
//   ["resources", "<type>", id, "sub"] → Sub-Resource (M2+, z.B. Sessions)
//
// Mit `invalidateQueries({queryKey: ["resources", "agents"]})` lassen sich
// gezielt alle Agent-Queries invalidieren (auch sub-trees), ohne andere
// Resources zu treffen. Wichtig für M2 Create/Update-Pfade.
export const queryKeys = {
  resource: (type: string) => ["resources", type] as const,
  list: (type: string) => ["resources", type, "list"] as const,
  detail: (type: string, id: string) => ["resources", type, id] as const,
  // Sub-Resource (M3): Sessions hängen am Agent. invalidateQueries auf den
  // Parent-Detail-Key matched NICHT die Sub-Listen (eigener Sub-Key-Pfad).
  subList: (type: string, id: string, sub: string) =>
    ["resources", type, id, sub, "list"] as const,
  subDetail: (type: string, id: string, sub: string, subId: string) =>
    ["resources", type, id, sub, subId] as const,
  subResource: (type: string, id: string, sub: string) =>
    ["resources", type, id, sub] as const,
};
